export default __webpack_public_path__ + "static/media/pic7.1daa6fef.jpg";